// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1my--","rootSmall":"AddTileButton_rootSmall__3eHHF"};